/**
 * Heinsson Dark Mode — Toggle Logic
 * ==================================
 * Manages dark/light theme switching with:
 * - localStorage persistence ('heinsson-theme')
 * - prefers-color-scheme MediaQuery listener
 * - Smooth icon transition (Sun ↔ Moon)
 *
 * NOTE: The initial theme is set by an inline <script> in theme.liquid
 *       to prevent Flash of Wrong Theme. This file handles the toggle
 *       button interaction and live OS-preference changes.
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'heinsson-theme';

  /* --- SVG Icons (inline, no external load) --- */
  var ICON_SUN =
    '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">' +
    '<circle cx="12" cy="12" r="4.3"/>' +
    '<path d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.2 5.2l1.6 1.6M17.2 17.2l1.6 1.6M18.8 5.2l-1.6 1.6M6.8 17.2l-1.6 1.6"/>' +
    '</svg>';

  var ICON_MOON =
    '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M20 14.3A8 8 0 0 1 9.7 4 6.5 6.5 0 1 0 20 14.3z"/>' +
    '</svg>';

  /** Read the current effective theme from <html> attribute */
  function getCurrentTheme() {
    return document.documentElement.getAttribute('data-theme') || 'light';
  }

  /** Apply theme to DOM and update all toggle buttons */
  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);

    // Update all toggle buttons (desktop + mobile)
    var buttons = document.querySelectorAll('.dark-mode-toggle__btn');
    var isDark = theme === 'dark';

    buttons.forEach(function (btn) {
      btn.innerHTML = isDark ? ICON_SUN : ICON_MOON;
      btn.setAttribute(
        'aria-label',
        isDark ? 'Zum hellen Modus wechseln' : 'Zum dunklen Modus wechseln'
      );
    });
  }

  /** Toggle between dark and light, persist choice */
  function toggleTheme() {
    var current = getCurrentTheme();
    var next = current === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* localStorage not available — silent fail */
    }
  }

  /**
   * Listen for OS-level color scheme changes.
   * Only respond if user has NOT manually set a preference.
   */
  function listenForOSChanges() {
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    if (!mq || !mq.addEventListener) return;

    mq.addEventListener('change', function (e) {
      var manual = null;
      try {
        manual = localStorage.getItem(STORAGE_KEY);
      } catch (err) {
        /* silent */
      }
      // Only auto-switch if user hasn't manually chosen
      if (!manual) {
        applyTheme(e.matches ? 'dark' : 'light');
      }
    });
  }

  /** Bind click handlers to all toggle buttons */
  function bindToggles() {
    var buttons = document.querySelectorAll('.dark-mode-toggle__btn');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleTheme();
      });
    });
  }

  /** Initialize: set icon state, bind events */
  function init() {
    // Icon state matches current theme (already set by inline script)
    applyTheme(getCurrentTheme());
    bindToggles();
    listenForOSChanges();
  }

  // Run on DOMContentLoaded (deferred script)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after Shopify section rendering (Theme Editor support)
  document.addEventListener('shopify:section:load', function () {
    bindToggles();
    applyTheme(getCurrentTheme());
  });

  // Expose for potential external use
  window.heinssonDarkMode = {
    toggle: toggleTheme,
    apply: applyTheme,
    current: getCurrentTheme
  };
})();
